import DataGrid from '../../../../../table/DataGrid'
import FormatDate from '../../../../../date/FormatDate'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Chip } from '@mui/material'
import useFetchData from '../../../../../../hooks/useFetchData'
import { useParams } from 'react-router-dom'
import LinearProgressWithLabel from '../../../../../commom/Loading/LinearProgressWithLabel'
import { formatDuration } from '../../../../../../utils/date'

const FormSyncHistory = () => {
  const { periodicalReportId } = useParams()
  const { isLoading, data } = useFetchData(`periodical-report/${periodicalReportId}/sync-history`)

  const GetIcon = ({ status }) => {
    if (status === 'completed') {
      return <FontAwesomeIcon icon='check-circle' size='sm' className='text-green-500' />
    }
    if (status === 'syncing') {
      return <FontAwesomeIcon icon='sync' spin size='sm' className='text-blue-500' />
    }
    if (status === 'failed') {
      return <FontAwesomeIcon icon='times-circle' size='sm' className='text-red-500' />
    }
    return null
  }

  const syncForText = (filters, students) => {
    const texts = ['Sync for ', <b key='students'>{students}</b>, ' students. ']
    if (filters.yearLevel) {
      texts.push(
        <div key='yearLevel'>
          Year Level: <b className='text-primary'>{filters.yearLevel.name || filters.yearLevel._id}</b>{' '}
        </div>
      )
    }
    if (filters.element) {
      texts.push(
        <div key='element'>
          Learning area: <b className='text-primary'>{filters.element.name || filters.element._id}</b>{' '}
        </div>
      )
    }

    if (filters.assessmentArea) {
      texts.push(
        <div key='assessmentArea'>
          Assessment area:{' '}
          <b className='text-primary'>{filters.assessmentArea.name || filters.assessmentArea._id}</b>{' '}
        </div>
      )
    }
    if (filters.yearLevels) {
      texts.push(
        <div key='yearLevels'>
          Year Levels:{' '}
          <b className='text-primary'>{filters.yearLevels.map((yl) => yl.name || yl._id).join(', ')}</b>{' '}
        </div>
      )
    }
    return <div>{texts}</div>
  }

  return (
    <DataGrid
      showSetting={false}
      id='table-logs'
      loading={isLoading}
      columns={[
        { label: '#', key: 'index', show: true, hide: false, width: 10 },
        { label: '', key: 'status', show: true, hide: false, width: 10 },
        { label: 'description', key: 'filters', show: true, hide: false },
        { label: 'started at', key: 'startedAt', show: true, hide: false, width: 80 },
        { label: 'progress', key: 'progress', show: true, hide: false, width: 200 },
        { label: 'duration', key: 'duration', show: true, hide: false }
      ]}
      orderByField='startedAt'
      orderOrder='desc'
      rowsPerPage={data?.length || 10}
      rows={data?.map((row, index) => ({
        ...row,
        _id: new Date(row.date).getTime() + index,
        progress: <LinearProgressWithLabel value={row.progress} />,
        status: (
          <Chip
            label={row.status.replace(/-/g, ' ').toUpperCase()}
            size='small'
            color={
              row.status === 'completed'
                ? 'success'
                : row.status === 'syncing'
                  ? 'info'
                  : row.status === 'failed'
                    ? 'error'
                    : 'default'
            }
            icon={<GetIcon status={row.status} />}
          />
        ),
        startedAt: <FormatDate date={row.startedAt} pattern='dd/MMM/yyyy hh:mm a' />,
        finishedAt: row.finishedAt ? (
          <FormatDate date={row.finishedAt} pattern='dd/MMM/yyyy hh:mm a' />
        ) : (
          <Chip label=' - ' size='small' />
        ),
        filters: syncForText(row?.data?.filters, row?.data?.studentsLength || 0),
        duration: row.finishedAt ? (
          <>{formatDuration(new Date(row.startedAt), new Date(row.finishedAt))}</>
        ) : (
          '-'
        )
      }))}
      labelNoRows="You don't have any history yet"
    />
  )
}

export default FormSyncHistory
